import { render, staticRenderFns } from "./BettingAdd.vue?vue&type=template&id=2675aa74&scoped=true"
import script from "./BettingAdd.vue?vue&type=script&lang=js"
export * from "./BettingAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2675aa74",
  null
  
)

export default component.exports